/**
 * Shared utilities for the SafeRoutePanel and its hooks.
 */

export const REROUTE_INTERVAL_MS = 60_000;
// Arrival detection: stop Live re-route once the driver dwells within
// ARRIVAL_RADIUS_M of the destination for ARRIVAL_DWELL_MS.
export const ARRIVAL_RADIUS_M = 100;
export const ARRIVAL_DWELL_MS = 30_000;

/** Great-circle distance in metres between two {latitude, longitude} points. */
export function haversineM(a, b) {
  if (!a || !b || typeof a.latitude !== "number" || typeof b.latitude !== "number") return Infinity;
  const R = 6_371_000;
  const toRad = (d) => (d * Math.PI) / 180;
  const p1 = toRad(a.latitude);
  const p2 = toRad(b.latitude);
  const dp = toRad(b.latitude - a.latitude);
  const dl = toRad(b.longitude - a.longitude);
  const s = Math.sin(dp / 2) ** 2 + Math.cos(p1) * Math.cos(p2) * Math.sin(dl / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
}

export function formatMin(m) {
  if (typeof m !== "number" || isNaN(m)) return "–";
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${m % 60} m`;
}

/**
 * Detect feature support for the Web Speech API (Chrome/Edge ship it under
 * webkit-prefix). Returns null on unsupported browsers.
 */
export function getSpeechRecognitionCtor() {
  if (typeof window === "undefined") return null;
  return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}
